import loadable from '@loadable/component';

const TermsLoadable = loadable(() => import(/* webpackChunkName: 'Fulfilment' */ './Fulfilment'));

const Terms = () => <TermsLoadable />;

export default Terms;
